import { createContext, SetStateAction } from "react"

export const AlertContext = createContext<SetStateAction<any>>({
  caller: () => {},
})
